/**
 * Must match the gtag snippet in public/index.html unless you change both.
 * CRA only exposes env vars prefixed with REACT_APP_.
 */
export const GA_MEASUREMENT_ID =
  (typeof process !== "undefined" &&
    process.env.REACT_APP_GA_TRACKING_ID &&
    process.env.REACT_APP_GA_TRACKING_ID.trim()) ||
  "G-7LXDBSGXS0";
